var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcRoundPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9993 17.3307H17.3327V23.9974C17.3327 24.351 17.1922 24.6902 16.9422 24.9402C16.6921 25.1903 16.353 25.3307 15.9993 25.3307C15.6457 25.3307 15.3066 25.1903 15.0565 24.9402C14.8065 24.6902 14.666 24.351 14.666 23.9974V17.3307H7.99935C7.64573 17.3307 7.30659 17.1903 7.05654 16.9402C6.80649 16.6902 6.66602 16.351 6.66602 15.9974C6.66602 15.6438 6.80649 15.3046 7.05654 15.0546C7.30659 14.8045 7.64573 14.6641 7.99935 14.6641H14.666V7.9974C14.666 7.64377 14.8065 7.30463 15.0565 7.05459C15.3066 6.80454 15.6457 6.66406 15.9993 6.66406C16.353 6.66406 16.6921 6.80454 16.9422 7.05459C17.1922 7.30463 17.3327 7.64377 17.3327 7.9974V14.6641H23.9993C24.353 14.6641 24.6921 14.8045 24.9422 15.0546C25.1922 15.3046 25.3327 15.6438 25.3327 15.9974C25.3327 16.351 25.1922 16.6902 24.9422 16.9402C24.6921 17.1903 24.353 17.3307 23.9993 17.3307Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRoundPlus);
export default __webpack_public_path__ + "static/media/ic_round-plus.e117190dd5c1fb4af82e2ac6c4f21e1d.svg";
export { ForwardRef as ReactComponent };